import { createComponent } from '@carvana/vdp-components';

export const ViewAllButton = createComponent('div', {
  className:
    'bg-blue-2 flex font-bold h-[38px] hover:text-white items-center justify-center leading-[16px] mt-16 rounded-md text-[12px] text-white uppercase w-full'
});
